import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {
  lighten,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { useTranslation } from 'next-i18next';
import { OfficialFilingType } from 'typings/markets/api';
import Typography from '../../components/Typography';
import Spacer from '@/components/ui-components/Spacer';

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: lighten(theme.palette.primary.light, 0.8),
  },
  websiteLink: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
}));

interface Props {
  items: OfficialFilingType[];
}
const defaultProps = {};

const OfficialFilings = ({ items }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation('markets');
  return (
    <>
      <Typography variant="header">
        {t('markets.detailView.officialFilings.title')}
      </Typography>
      <Spacer spacing={2} />
      <TableContainer>
        <Table aira-label="FinancialsTable">
          <TableHead className={classes.header}>
            <TableRow>
              <TableCell>
                <Typography variant="baseBold">
                  {t('markets.detailView.officialFilings.date')}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="baseBold" align="right">
                  {t('markets.detailView.officialFilings.formType')}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="baseBold" align="right">
                  {t('markets.detailView.officialFilings.seeOnEdgar')}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items?.map((row) => (
              <>
                <TableRow>
                  <TableCell>
                    <Typography variant="secondary2">{row.date}</Typography>
                  </TableCell>

                  <TableCell>
                    <Typography variant="secondary2" align="right">
                      {/* {`${row.form_type} (${row.motive})`} */}
                      {row.form_type}
                      {' '}
                      (
                      {row.motive?.toLowerCase()}
                      )
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <a href={row.url!}>
                      <Typography
                        variant="secondaryBold"
                        align="right"
                        color="primary"
                      >
                        {t('markets.detailView.officialFilings.seeOnEdgar')}
                      </Typography>
                    </a>
                  </TableCell>
                </TableRow>
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

OfficialFilings.defaultProps = (defaultProps as unknown) as Partial<Props>;

export default OfficialFilings;
